import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

export default function EleccionesEstudiante() {
  const { token } = useAuth();
  const [elecciones, setElecciones] = useState([]);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fetchElecciones = async () => {
      try {
        const res = await axios.get(`${API_BASE}/elecciones/activas`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setElecciones(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchElecciones();
  }, [token]);

  const votar = async (eleccionId, candidatoId) => {
    try {
      await axios.post(
        `${API_BASE}/elecciones/votar`,
        { eleccion_id: eleccionId, candidato_id: candidatoId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMensaje("✅ Voto registrado");
    } catch (err) {
      setMensaje(err.response?.data?.message || "Error al votar");
    }
  };

  return (
    <div>
      <h2>Elecciones activas</h2>
      {mensaje && <p>{mensaje}</p>}
      {elecciones.length === 0 ? (
        <p>No hay elecciones activas</p>
      ) : (
        elecciones.map((e) => (
          <div key={e.id} style={{ border: "1px solid #ccc", margin: 10, padding: 10 }}>
            <h3>{e.nombre}</h3>
            <p>{e.descripcion}</p>
            <EleccionDetalle eleccionId={e.id} votar={votar} />
          </div>
        ))
      )}
    </div>
  );
}

function EleccionDetalle({ eleccionId, votar }) {
  const { token } = useAuth();
  const [candidatos, setCandidatos] = useState([]);

  useEffect(() => {
    const fetchCandidatos = async () => {
      try {
        const res = await axios.get(`${API_BASE}/candidatos/${eleccionId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCandidatos(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCandidatos();
  }, [eleccionId, token]);

  return (
    <div>
      {candidatos.map((c) => (
        <div key={c.id} style={{ marginBottom: 5 }}>
          <img src={c.foto_cache || `https://ui-avatars.com/api/?name=${c.nombre_cache}`} alt={c.nombre_cache} width={50} style={{ marginRight: 10 }} />
          <span>{c.nombre_cache}</span>
          <button style={{ marginLeft: 10 }} onClick={() => votar(eleccionId, c.id)}>
            Votar
          </button>
        </div>
      ))}
    </div>
  );
}
